import { render, staticRenderFns } from "./ContentIndex.vue?vue&type=template&id=1796d4d4&scoped=true&"
import script from "./ContentIndex.vue?vue&type=script&lang=js&"
export * from "./ContentIndex.vue?vue&type=script&lang=js&"
import style0 from "./ContentIndex.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"
import style1 from "./ContentIndex.vue?vue&type=style&index=1&id=1796d4d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1796d4d4",
  null
  
)

export default component.exports